
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 39 39"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#00CAC1","d":"M16.917.151S18.208 0 19.5 0s2.584.151 2.584.151l1.094 4.683c1.459.365 2.834.942 4.09 1.696l4.087-2.539s1.02.807 1.934 1.72c.913.914 1.72 1.934 1.72 1.934l-2.539 4.087a15 15 0 0 1 1.696 4.09l4.683 1.095S39 18.208 39 19.5s-.151 2.584-.151 2.584l-4.683 1.094a15 15 0 0 1-1.696 4.09l2.538 4.087s-.806 1.02-1.72 1.934a26 26 0 0 1-1.933 1.72l-4.087-2.539a15 15 0 0 1-4.09 1.696l-1.094 4.683S20.792 39 19.5 39s-2.584-.151-2.584-.151l-1.094-4.683a15 15 0 0 1-4.09-1.696l-4.087 2.538s-1.02-.806-1.934-1.72-1.72-1.933-1.72-1.933l2.539-4.087a15 15 0 0 1-1.696-4.09L.151 22.084S0 20.792 0 19.5s.151-2.584.151-2.584l4.683-1.094c.365-1.459.942-2.834 1.696-4.09L3.99 7.645s.807-1.02 1.72-1.934c.914-.913 1.934-1.72 1.934-1.72l4.087 2.539a15 15 0 0 1 4.09-1.696z"}}),_c('path',{attrs:{"stroke":"#09A098","stroke-width":"5.695","d":"M10.479 28.944A13.06 13.06 0 0 0 29.81 11.489"}}),_c('path',{attrs:{"stroke":"#234652","stroke-dasharray":"0.97 1.63","stroke-width":".487","d":"M20.049 31.553A11.988 11.988 0 1 0 8.036 16.317"}}),_c('ellipse',{attrs:{"cx":"4.591","cy":"4.549","fill":"#EDF4F4","rx":"4.591","ry":"4.549","transform":"matrix(1 0 0 -1 14.95 24.047)"}})])
          )
        }
      }
    